import logo from './logo.svg';
import { connect } from 'react-redux';

import './App.css';
import Routes from "./routes";
import { getDataFromLocal } from "./store/auth/actions"
import { useEffect } from 'react';
import WarningBanner from './container/BrowserWarning';
function App(props) {
    useEffect(() => {
        props.getDataFromLocal()
    }, [])

    function isSafeExamBrowser() {
        // REACT_APP_SEB_CHECK = 0 in the build params turns the Safe Exam Browser check off; anything else, or the
        // key missing, keeps it on
        if (String(process.env.REACT_APP_SEB_CHECK ?? "").trim() === "0") {
            return true;
        }
        // Stage and local development run in an ordinary browser; production builds don't set this
        if(["stage", "development"].includes(process.env.REACT_APP_ENVIRONMENT)){
            return true;
        }
        const ua = navigator.userAgent.toLowerCase();

        // SEB usually contains "seb" in the user-agent
        if (ua.includes("seb")) return true;

        // SEB adds special properties
        if (navigator.safeExamBrowser || window.safeExamBrowser) return true;

        // SEB config API sometimes injects this object
        if (typeof SEB !== "undefined") return true;

        // SEB on Windows/macOS may expose this header value (if forwarded)
        // Not always available in JS, but included for completeness
        if (ua.includes("safe exam browser")) return true;

        return false;
    }

    return (
        <div className="App">
            {
                !isSafeExamBrowser() ?
                <WarningBanner /> : <Routes />
            }
        </div>
    );
}


const mapStateToProps = (state) => {
    return {
        auth: state.Auth
    }
}

const mapDispatchToProps = { getDataFromLocal }
export default connect(mapStateToProps, mapDispatchToProps)(App);

